<template src='./ChatboxNuevo.html'></template>
<script>
import { enviarMensaje } from "../../../apiService/request/df_client";
import Sugerencias from "../../Chatbox/Sugerencias/Sugerencias";
import { serverBus } from "../../../main";
import CChatBox from "../../../js/componentes/CChatBox";
import Icono from "../../Icono/Icono";
import Microfono from "../../Microfono/Microfono";
// import ChatBox from "../../../js/modules/ChatBox";

export default {
  data() {
    return {
      banderaCerrado: false,
      autogrow: null,
      mensaje: "Hola",
      mensaje_visualizado: [],
      sugerencias: [],
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
      iconoCerrar:
        "M43.7,42.3c0.4,0.4,0.4,1,0,1.4C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L22,23.4L1.7,43.7C1.5,43.9,1.3,44,1,44s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.6,22L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L22,20.6L42.3,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L23.4,22L43.7,42.3z",
      iconoOcultar:
        "M43,0h-8c-0.6,0-1,0.4-1,1v42c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V1C44,0.4,43.6,0,43,0z M42,42h-6V2h6V42z M30,22c0,0.6-0.4,1-1,1H3.4l8.3,8.3c0.4,0.4,0.4,1,0,1.4C11.5,32.9,11.3,33,11,33s-0.5-0.1-0.7-0.3l-10-10c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.1-0.5,0-0.8c0.1-0.1,0.1-0.2,0.2-0.3l10-10c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L3.4,21H29C29.6,21,30,21.4,30,22z",
      iconoPaciente:
        "M22,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S25.3,12,22,12z M22,2c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S24.2,2,22,2zM26,44c-1.7,0-3-1.3-3-3V29h-2v12c0,1.7-1.3,3-3,3s-3-1.3-3-3V22.4l-3.7,3.7c-1.2,1.2-3.2,1.2-4.4,0c-1.2-1.2-1.2-3.2,0-4.4l8.4-8.4c0.2-0.2,0.4-0.3,0.7-0.3h12c0.3,0,0.5,0.1,0.7,0.3l8.4,8.4c1.2,1.2,1.2,3.2,0,4.4c-1.2,1.2-3.2,1.2-4.4,0L29,22.4V41C29,42.7,27.7,44,26,44z M20,27h4c0.6,0,1,0.4,1,1v13c0,0.6,0.4,1,1,1s1-0.4,1-1V19.9c0-0.4,0.2-0.8,0.6-0.9s0.8-0.1,1.1,0.2l5.4,5.4c0.4,0.4,1.1,0.4,1.6,0c0.4-0.4,0.4-1.1,0-1.6L27.6,15H16.4l-8.1,8.1c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l5.4-5.4c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.2,0.6,0.5,0.6,0.9V41c0,0.6,0.4,1,1,1s1-0.4,1-1V28C19,27.4,19.4,27,20,27z M44,0v44 M0,0v44",
      iconoBuscar:
        "M17.8,27.8c0,0.6-0.4,1-1,1c-6.7,0-12.1-5.4-12.1-12.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,5.6,4.5,10.1,10.1,10.1C17.3,26.8,17.8,27.3,17.8,27.8z M43.7,43.7C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L27.8,29.3c-3,2.6-6.8,4.2-11.1,4.2C7.5,33.5,0,26,0,16.8S7.5,0,16.8,0s16.8,7.5,16.8,16.8c0,4.3-1.6,8.1-4.2,11.1l14.4,14.4C44.1,42.7,44.1,43.3,43.7,43.7zM16.8,31.5c8.1,0,14.8-6.6,14.8-14.8S24.9,2,16.8,2S2,8.6,2,16.8S8.6,31.5,16.8,31.5z",
      iconoOpciones:
        "M1,38c-0.2,0-0.3,0-0.5-0.1C0.2,37.7,0,37.4,0,37V8c0-1.1,0.9-2,2-2h40c1.1,0,2,0.9,2,2v22c0,1.1-0.9,2-2,2H10.3l-8.7,5.8C1.4,37.9,1.2,38,1,38z M42,8L2,8l0,27.1l7.4-5C9.6,30.1,9.8,30,10,30h32L42,8z M11.5,23h-3C6.6,23,5,21.4,5,19.5S6.6,16,8.5,16h3c1.9,0,3.5,1.6,3.5,3.5S13.4,23,11.5,23z M8.5,18C7.7,18,7,18.7,7,19.5S7.7,21,8.5,21h3c0.8,0,1.5-0.7,1.5-1.5S12.3,18,11.5,18H8.5zM23.5,23h-3c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h3c1.9,0,3.5,1.6,3.5,3.5S25.4,23,23.5,23z M20.5,18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h3c0.8,0,1.5-0.7,1.5-1.5S24.3,18,23.5,18H20.5z M35.5,23h-3c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h3c1.9,0,3.5,1.6,3.5,3.5S37.4,23,35.5,23z M32.5,18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h3c0.8,0,1.5-0.7,1.5-1.5S36.3,18,35.5,18H32.5z M0,0h44 M0,44h44",
      procesarCedula: false,
      fab: false
    };
  },
  created() {
    serverBus.$on("sugerenciaSeleccionada", sugerenciaSeleccionada => {
      this.interaccionDialogflow(sugerenciaSeleccionada);
    });
    this.interaccionDialogflow(this.mensaje);
  },
  beforeDestroy() {
    /**Se utiliza para apagar los serverbus cuando no se esten utilizando */
    serverBus.$off("sugerenciaSeleccionada");
  },
  updated() {
    this.scrollToEnd();
  },
  beforeUpdate() {
    this.scrollToEnd();
  },

  components: {
    Sugerencias,
    Icono,
    Microfono
  },
  props: {
    chatAbierto: {
      type: Boolean
    },
    chatCerrado: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getInicioChat() {
      if (this.$store.getters.getInicioChat != null) {
        this.interaccionDialogflow(this.$store.state.provider_email);
        this.$store.dispatch("setInicioChat", null);
      }
      return this.$store.getters.getInicioChat;
    },
    getMensajeChatBox() {
      if (this.$store.getters.getMensajeChatBox != null) {
        this.interaccionDialogflow(this.$store.getters.getMensajeChatBox);
        this.$store.dispatch("setMensajeChatBox", null);
      }
      return this.$store.getters.getMensajeChatBox;
    }
  },
  watch: {
    getInicioChat() {},
    getMensajeChatBox() {},
    chatAbierto(){
      this.llamarScrollTrancision();
}
  },
  methods: {
    llamarScrollTrancision(){
           let chat = document.getElementById("chatBox");
      console.log('chat');
      chat.ontransitionend = function() {
              let container = document.querySelector(".EsquemaChat");
      let scrollHeight = container.scrollHeight;      
      container.scrollTop = scrollHeight;
      };
    },
    enviarShortCut(mensaje) {
      this.$store.dispatch("setMensajeChatBox", mensaje);
    },
    cerrarChat() {
      this.$emit("cerrarChat", !this.banderaCerrado);
    },
    async interaccionDialogflow(mensaje) {
      try {
        this.mensaje_visualizado.push({ mensaje: mensaje, fuente: "usuario" });
        const result = await enviarMensaje(
          mensaje,
          this.$store.state.provider_email
        );
        this.mensaje = "";
        this.mensaje_visualizado.push({
          mensaje: result.data.response,
          fuente: "bot"
        });
        this.enviarSugerencias(result.data.sugerencias);
        this.scrollToEnd();
        this.analisisRespuesta(result);
      } catch (err) {}
    },
    scrollToEnd() {
      let container = document.querySelector(".EsquemaChat");
      let scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    enviarSugerencias(sugerencias) {
      this.sugerencias = sugerencias;
      this.$store.dispatch("setCargando", false);
    },
    analisisRespuesta: function(respuesta) {
      // this.cargando=true
      this.guardarDocumento(respuesta);
      CChatBox.enrutadorChatBox(
        respuesta.data.variables_front.data.action,
        respuesta.data.variables_front.data
      ).then(([matrizActionValor, valorCambiaPanelLateral]) => {
        this.cargando = false;
        this.realizarDispatch(this, matrizActionValor).then(() => {
          this.cambiaPanelLateral(valorCambiaPanelLateral);
        });
      });
    },
    guardarDocumento: function(respuesta) {
      if (respuesta.data.variables_front.data.documento) {
        this.$store.dispatch("setCedulaPaciente", null);
        this.$store.dispatch(
          "setCedulaPaciente",
          Number(respuesta.data.variables_front.data.documento)
        );
      }
      if (respuesta.data.variables_front.data.cedula) {
        this.$store.dispatch("setCedulaPaciente", null);
        this.$store.dispatch(
          "setCedulaPaciente",
          Number(respuesta.data.variables_front.data.cedula)
        );
      }
    },
    realizarDispatch: function(contexto, matrizActionValor) {
      return new Promise((resolve, reject) => {
        matrizActionValor.map(
          function(valor) {
            this.$store.dispatch(valor.accionStore, valor.valor);
          }.bind(contexto)
        );
        resolve(true);
      });
    },
    cambiaPanelLateral(estado) {
      this.$store.dispatch("setestadoPanel", estado);
    }
  }
};
</script>
<style lang="scss" scoped src='./ChatboxNuevo.scss'>
</style>



// WEBPACK FOOTER //
// src/components/Chatbox/ChatboxNuevo/ChatboxNuevo.vue